import reactContainerFactory from '@/components/react-container/reactContainerFactory';
import { hasPermission } from '@/utils/checkPermission';
import { lazy } from 'react';

const exceptionCenter = {
  path: '/exceptionCenter',
  name: 'exceptionCenter',
  meta: {
    title: 'Exception Center',
    icon: 'Exception Center',
  },
  redirect: '/troubleshoottask',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      path: '/troubleshoottask',
      name: 'exceptionCenter.ibTroubleshootTask',
      meta: {
        title: 'IB Troubleshoot Task',
        filterSave: true,
      },
      component: () =>
        import(
          '../../views/exception-center/troubleshoot-task/troubleshoot-task.vue'
        ),
    },
    {
      path: '/troubleshoottaskdetail',
      name: 'exceptionCenter.ibTroubleshootTaskdetail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'exceptionCenter',
            title: 'Exception Center',
          },
          {
            routeName: 'exceptionCenter.ibTroubleshootTask',
            title: 'IB Troubleshoot',
          },
        ],
      },
      component: () =>
        import(
          '../../views/exception-center/troubleshoot-task/troubleshoot-task-detail.vue'
        ),
    },
    {
      path: '/troubleshoottaskhandle',
      name: 'exceptionCenter.ibTroubleshootTaskhandle',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'exceptionCenter',
            title: 'Exception Center',
          },
          {
            routeName: 'exceptionCenter.ibTroubleshootTask',
            title: 'IB Troubleshoot',
          },
        ],
      },
      component: () =>
        import(
          '../../views/exception-center/troubleshoot-task/troubleshoot-task-detail.vue'
        ),
    },
    {
      path: 'mtToWhTask',
      name: 'exceptionCenter.mttroubleshoottask',
      meta: {
        title: 'MT Troubleshoot Task',
      },
      component: () =>
        import(
          '../../views/exception-center/mt-troubleshoot-task/mt-to-wh.vue'
        ),
    },
    {
      path: 'mtFromWhTask',
      name: 'PC.ExceptionCenter.MTTroubleshootTask.MTFromCurrentWH',
      meta: {
        menuHide: true,
        title: 'MT Troubleshoot Task',
      },
      component: () =>
        import(
          '../../views/exception-center/mt-troubleshoot-task/mt-from-wh.vue'
        ),
    },
    {
      path: 'mtTroubleshootTask/detail',
      name: 'exceptionCenter.mtTroubleshootTaskDetail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'exceptionCenter',
            title: 'Exception Center',
          },
          {
            routeName: 'exceptionCenter.mttroubleshoottask',
            title: 'MT Troubleshoot Task Detail',
          },
        ],
      },
      component: () =>
        import(
          '../../views/exception-center/mt-troubleshoot-task/mt-troubleshoot-task-detail.vue'
        ),
    },
    {
      path: 'mtTroubleshootTask/handle',
      name: 'exceptionCenter.mtTroubleshootTaskHandle',
      meta: {
        title: 'Handle',
        menuHide: true,
        navList: [
          {
            routeName: 'exceptionCenter',
            title: 'Exception Center',
          },
          {
            routeName: 'exceptionCenter.mttroubleshoottask',
            title: 'MT Troubleshoot Task Detail',
          },
        ],
      },
      component: () =>
        import(
          '../../views/exception-center/mt-troubleshoot-task/mt-troubleshoot-task-detail.vue'
        ),
    },
    {
      path: '/reverse-picking-requirement',
      name: 'exceptionCenter.reversepickingrequirement',
      meta: {
        title: 'Reverse Picking Requirement',
      },
      component: reactContainerFactory({
        name: 'exceptionCenter.reversepickingrequirement',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '@/react-app/pages/exception-center/reverse-picking-requirement/index'
              )
          ),
      },
    },
    {
      path: '/ob-troubleshoot-task',
      name: 'exceptionCenter.obTroubleshootTask',
      meta: {
        title: 'OB Troubleshoot Task',
        filterSave: true,
      },
      component: () =>
        import(
          '../../views/exception-center/ob-troubleshoot-task/ob-troubleshoot-task.vue'
        ),
    },
    {
      path: '/ob-troubleshoot-task-detail/:task_id',
      name: 'exceptionCenter.obTroubleshootTask.detail',
      meta: {
        title: 'Detail',
        menuHide: true,
        navList: [
          {
            routeName: 'exceptionCenter',
            title: 'Exception Center',
          },
          {
            routeName: 'exceptionCenter.obTroubleshootTask',
            title: 'OB Troubleshoot Task',
          },
        ],
      },
      component: () =>
        import(
          '../../views/exception-center/ob-troubleshoot-task/ob-troubleshoot-task-detail.vue'
        ),
    },
    {
      path: 'rttroubleshoot',
      name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask',
      meta: {
        title: 'RT Troubleshoot Task',
      },
      component: () =>
        import(
          '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task'
        ),
      children: [
        {
          path: 'detail/:exception_id',
          name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.detail',
          meta: {
            title: 'Detail',
            menuHide: true,
          },
          exact: true,
          component: () =>
            import(
              '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/detail'
            ),
        },
        {
          path: 'progress/:exception_id',
          name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress',
          meta: {
            title: 'Progress',
            menuHide: true,
          },
          exact: true,
          component: () =>
            import(
              '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/progress'
            ),
        },
        {
          path: 'progress/:exception_id/:exception_sku_id',
          name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress.handlingDetail',
          meta: {
            title: 'Handling Detail',
            menuHide: true,
          },
          exact: true,
          component: () =>
            import(
              '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/handling-detail'
            ),
          children: [
            {
              path: 'detail/:exception_id',
              name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.detail',
              meta: {
                title: 'Detail',
                menuHide: true,
              },
              exact: true,
              component: () =>
                import(
                  '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/detail'
                ),
            },
            {
              path: 'progress/:exception_id',
              name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress',
              meta: {
                title: 'Progress',
                menuHide: true,
              },
              exact: true,
              component: () =>
                import(
                  '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/progress'
                ),
            },
            {
              path: 'progress/:exception_id/:exception_sku_id',
              name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress.handlingDetail',
              meta: {
                title: 'Handling Detail',
                menuHide: true,
              },
              exact: true,
              component: () =>
                import(
                  '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/handling-detail'
                ),
            },
          ],
        },
      ],
    },
    {
      path: '/jit-troubleshoot-task',
      name: 'exceptionCenter.jittroubleshoottask',
      meta: {
        title: 'JIT Troubleshoot Task',
        filterSave: true,
      },
      component: reactContainerFactory({
        name: 'exceptionCenter.jitTroubleshootTask',
      }),
      props: {
        component: () =>
          lazy(
            () =>
              import(
                '../../react-app/pages/exception-center/jit-troubleshoot-task/index'
              )
          ),
      },
    },
    {
      path: '/sales-outbound-exception',
      name: 'exceptionCenter.salesoutboundexception',
      meta: {
        title: 'Sales Outbound Exception Record',
        filterSave: true,
      },
      component: () => import('../../views/layout/subPage.vue'),
      redirect: () => {
        const children = [
          {
            path: '/sales-outbound-exception/exception-record',
            permission:
              'exceptionCenter.salesoutboundexception.exceptionrecord',
          },
        ];
        const child = children.find((child) => hasPermission(child.permission));
        return child?.path ?? '/home';
      },
      children: [
        {
          path: 'exception-record',
          name: 'exceptionCenter.salesoutboundexception.exceptionrecord',
          meta: {
            title: 'Exception Record',
          },
          component: reactContainerFactory({
            name: 'exceptionCenter.salesoutboundexception.exceptionrecord',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/exception-center/sales-outbound-exception/exception-record/index'
                  )
              ),
          },
        },
        {
          path: 'exception-record/detail-page/:recordId',
          name: 'exceptionCenter.salesoutboundexception.exceptionrecord.detailpage',
          meta: {
            title: 'Detail',
            menuHide: true,
            navList: [
              {
                routeName: 'exceptionCenter',
                title: 'Exception Center',
              },
              {
                routeName: 'exceptionCenter.salesoutboundexception',
                title: 'Sales Outbound Exception Record',
              },
              {
                routeName:
                  'exceptionCenter.salesoutboundexception.exceptionrecord',
                title: 'Exception Record',
              },
            ],
          },
          component: reactContainerFactory({
            name: 'exceptionCenter.salesoutboundexception.exceptionrecord.detailpage',
          }),
          props: {
            component: () =>
              lazy(
                () =>
                  import(
                    '@/react-app/pages/exception-center/sales-outbound-exception/exception-record/detail-page/index'
                  )
              ),
          },
        },
      ],
    },
    // {
    //   path: 'ivtroubleshoot',
    //   name: 'exceptionCenter.ivTroubleshootTask',
    //   meta: {
    //     title: 'IV Troubleshoot Task',
    //   },
    //   component: () => import('@/views/layout/subPage.vue'),
    //   children: [
    //     {
    //       path: 'rttroubleshoot',
    //       name: 'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask',
    //       meta: {
    //         title: 'RT Troubleshoot Task',
    //       },
    //       component: () =>
    //         import(
    //           '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task'
    //         ),
    //       children: [
    //         {
    //           path: 'detail/:exception_id',
    //           name:
    //             'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.detail',
    //           meta: {
    //             title: 'Detail',
    //             menuHide: true,
    //           },
    //           exact: true,
    //           component: () =>
    //             import(
    //               '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/detail'
    //             ),
    //         },
    //         {
    //           path: 'progress/:exception_id',
    //           name:
    //             'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress',
    //           meta: {
    //             title: 'Progress',
    //             menuHide: true,
    //           },
    //           exact: true,
    //           component: () =>
    //             import(
    //               '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/progress'
    //             ),
    //         },
    //         {
    //           path: 'progress/:exception_id/:exception_sku_id',
    //           name:
    //             'exceptionCenter.ivTroubleshootTask.rtTroubleshootTask.progress.handlingDetail',
    //           meta: {
    //             title: 'Handling Detail',
    //             menuHide: true,
    //           },
    //           exact: true,
    //           component: () =>
    //             import(
    //               '@/views/exception-center/iv-troubleshoot-task/rt-troubleshoot-task/handling-detail'
    //             ),
    //         },
    //       ],
    //     },
    //   ],
    // },
  ],
};

export default exceptionCenter;
